
    import "src/app/AppSeller/SettingsPage/Api/index.module.scss?farm_css_modules";
    
    export default {"webhook_table": `webhook_table-b06d1efe`}
    